export default __webpack_public_path__ + "66dee1931ca89aad47da2ba16be985c6.webp";